import colors from './colors';
import analyseType from './analyseType';

export default {
  analyseType,
  colors,
};
